import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const MailIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" viewBox="0 0 28 28" {...props}>
      <path
        fill="currentColor"
        d="M2.004 7.75A3.75 3.75 0 0 1 5.754 4H22.25A3.75 3.75 0 0 1 26 7.75v.01l-12 6.147L2.004 7.764zm0 1.699v9.801A3.75 3.75 0 0 0 5.754 23H22.25A3.75 3.75 0 0 0 26 19.25V9.446l-11.658 5.972a.75.75 0 0 1-.684 0z"
      />
    </svg>
  );
};

export default MailIcon;
